<template>
  <div class="content_parent d-flex flex-column">
    <div class="content_line d-flex flex-row">
      <div class="content_title">
        <div class="texttitle">レース</div>
      </div>
      <div class="d-flex flex-row flex-wrap align-items-center">
        <div class="item_parent">
          <div class="row_texttitle">レース日</div>
          <div class="content_item">
            <VueCtkDateTimePicker
              button-now-translation="現在時刻"
              :button-clear="false"
              v-model="search_yoso.date"
              format="YYYY-MM-DD"
              formatted="YYYY年MM月DD日"
              :no-header="true"
              :no-button-now="true"
              label="日付を選択"
              no-label
              only-date
              no-clear-button
              auto-close
            />
          </div>
        </div>
        <div class="item_parent">
          <div class="row_texttitle">レース場</div>
          <div class="content_item">
            <select class="form-select" v-model="search_yoso.place">
              <option
                v-for="place in places"
                :value="place.value"
                :key="place.value"
              >
                {{ place.text }}
              </option>
            </select>
            <p v-if="isPlaceInvalid" class="error-message">
              レース場は必須項目です。
            </p>
          </div>
        </div>
        <div class="item_parent">
          <div class="row_texttitle">レース番号</div>
          <div class="content_item">
            <select class="form-select" v-model="search_yoso.race">
              <option
                v-for="raceNo in raceNos"
                :value="raceNo.value"
                :key="raceNo.value"
              >
                {{ raceNo.text }}
              </option>
            </select>
            <p v-if="isRaceInvalid" class="error-message">
              レース番号は必須項目です。
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="searched-race-box d-flex flex-row">
      <div class="search-button-box">
        <button
          :disabled="isSearching"
          class="submit_button search_race"
          @click="searchYoso"
        >
          検索
        </button>
      </div>
      <div class="searched-race">
        <div>レース日:{{ formattedDate(searched_yoso.date) }}</div>
        <div>レース場:{{ getMatchedText(searched_yoso.place, places) }}</div>
        <div>レース番号:{{ searched_yoso.race }}</div>
      </div>
    </div>
    <table
      class="yoso_table"
      :class="{ 'disabled-color': !isSearchButtonPushed }"
    >
      <thead>
        <tr class="table_waku_title">
          <th class="yoso-table-th table_name">名前</th>
          <th class="yoso-table-th table_writer">記者名</th>
          <th class="table_mark boat_color1">
            <div>1枠</div>
            <div>{{ players.player1 }}</div>
          </th>
          <th class="table_mark boat_color2">
            <div>2枠</div>
            <div>{{ players.player2 }}</div>
          </th>
          <th class="table_mark boat_color3">
            <div>3枠</div>
            <div>{{ players.player3 }}</div>
          </th>
          <th class="table_mark boat_color4">
            <div>4枠</div>
            <div>{{ players.player4 }}</div>
          </th>
          <th class="table_mark boat_color5">
            <div>5枠</div>
            <div>{{ players.player5 }}</div>
          </th>
          <th class="table_mark boat_color6">
            <div>6枠</div>
            <div>{{ players.player6 }}</div>
          </th>
          <th class="yoso-table-th table_turn">掲載優先順</th>
          <th class="yoso-table-th table_delete">削除</th>
        </tr>
      </thead>
      <tbody class="yoso-table-body">
        <tr
          class="yoso-table-tr"
          v-for="(yoso, index) in yosos.yoso"
          :key="index"
        >
          <td>
            <select
              :disabled="!isSearchButtonPushed"
              class="table_select"
              v-model.number="yoso.id"
              @change="updateJournalistName(yoso, index)"
            >
              <option
                v-for="(writer, index) in writers"
                :key="index"
                :value="writer.id"
              >
                {{ writer.name }}
              </option>
              <option value="0"></option>
            </select>
          </td>
          <td class="input_name">
            <input
              :disabled="!isSearchButtonPushed || !yoso.id"
              type="text"
              maxlength="6"
              v-model="yoso.writer"
            />
          </td>

          <td
            class="table-td-mark"
            v-for="i in 6"
            :key="i"
            :class="{ 'ketujou-disabled': absences[i - 1] && yoso.id !== 2 }"
          >
            <div class="ketujou" v-if="absences[i - 1] && yoso.id !== 2">
              欠場
            </div>

            <select
              :disabled="
                !isSearchButtonPushed ||
                (!yoso.id && !(yoso.id === 2)) ||
                (absences[i - 1] && !(yoso.id === 2))
              "
              v-model="yoso[`frame${i}`]"
            >
              <option value="1">◎</option>
              <option value="2">〇</option>
              <option value="3">△</option>
              <option value="4">×</option>
              <option value="0"></option>
            </select>
          </td>
          <td class="table_turn">
            <input
              :disabled="!isSearchButtonPushed || !yoso.id"
              type="number"
              min="0"
              maxlength="2"
              v-model="state.yosoTurn[index]"
              @input="updateYosoTurn(index, $event.target.value)"
            />
          </td>
          <td class="table_delete">
            <button
              :disabled="!isSearchButtonPushed || !yoso.id"
              @click="deleteLine(index, true)"
              class="submit_button delete_button"
            >
              削除
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="content_line d-flex flex-row">
      <div class="content_title">
        <div class="texttitle_wrap">公開日時</div>
      </div>
      <div class="d-flex flex-row flex-wrap">
        <div class="item_parent">
          <div class="content_item">
            <div class="d-flex flex-row mt-1">
              <VueCtkDateTimePicker
                button-now-translation="現在時刻"
                :disabled="!isSearchButtonPushed"
                class=""
                v-model="yosos.fromDate"
                :button-clear="false"
                format="YYYY-MM-DDTHH:mm"
                formatted="YYYY年MM月DD日 HH:mm"
                label="日付を選択"
                :no-header="true"
                id="fromDate"
                no-label
                auto-close
                no-clear-button
              />

              <span class="span-nami">～</span>
              <VueCtkDateTimePicker
                button-now-translation="現在時刻"
                :disabled="!isSearchButtonPushed"
                class=""
                v-model="yosos.toDate"
                label="日付を選択"
                :button-clear="false"
                format="YYYY-MM-DDTHH:mm"
                formatted="YYYY年MM月DD日 HH:mm"
                :no-header="true"
                id="toDate"
                no-label
                auto-close
                no-clear-button
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title content_line d-flex frex-row">
      <div class="item_parent">
        <div class="content_item mx-2">
          <div class="form-check">
            <label for="immediatelyOpen" class="ms-1 font-bold form-check-label"
              >即時公開</label
            >
            <input
              class="form-check-input"
              :disabled="!isSearchButtonPushed"
              id="immediatelyOpen"
              type="checkbox"
              v-model="checkboxImmediatelyOpen"
            />
          </div>
        </div>
      </div>

      <div class="item_parent">
        <div class="row_texttitle">承認</div>
        <div class="content_item">
          <select
            :disabled="
              !isSearchButtonPushed ||
              !hasPermission(roleStore.role, 'PUBLISH_INSTANTLY')
            "
            class="form-select"
            v-model="yosos.approval"
          >
            <option value="2">未承認</option>
            <option value="1">承認</option>
            <option value="3">却下</option>
          </select>
        </div>
      </div>
    </div>
    <div class="send_button">
      <div class="separate d-flex frex-row">
        <button
          class="submit_button"
          :disabled="
            !hasPermission(roleStore.role, 'PREDICTION') ||
            !isSearchButtonPushed
          "
          @click="sendYoso"
        >
          登録
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { ref, computed, watch, reactive, onMounted } from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { useStore } from "@/store/authStore";
import { format } from "date-fns";
import useRole from "@/components/role";
import { useRoleStore } from "@/store/roleStore";
import { useCodeStore } from "@/store/codeStore";
import { useApiStore } from "@/store/apiStore";
const apiStore = useApiStore();
const roleStore = useRoleStore();
const { hasPermission } = useRole();
const store = useStore(); // Pinia storeを使用
const codeStore = useCodeStore();
const router = useRouter();
const route = useRoute();
const yosos = reactive({
  yoso: Array.from({ length: 5 }, () => ({
    id: 0,
    writer: "",
    frame1: 0,
    frame2: 0,
    frame3: 0,
    frame4: 0,
    frame5: 0,
    frame6: 0,
    turn: 0,
  })),
  koshinId: 0,
  fromDate: (() => {
    const d = new Date();
    d.setHours(22, 0, 0, 0);
    return d;
  })(),
  toDate: new Date(2099, 11, 31, 23, 59, 59),
  immediatelyOpen: 0,
  approval: 2,
});

const checkboxImmediatelyOpen = computed({
  get: () => yosos.immediatelyOpen === 1,
  set: (value) => {
    yosos.immediatelyOpen = value ? 1 : 0;

    if (value) {
      const now = new Date();
      yosos.fromDate = now;
      yosos.approval = 1; // 承認に設定
    }
  },
});

// チェックボックスの値を監視
watch(checkboxImmediatelyOpen, (newValue) => {
  yosos.immediatelyOpen = newValue ? 1 : 0;

  if (newValue) {
    const now = new Date();
    yosos.fromDate = now;
    yosos.approval = 1; // 承認に設定
  }
});

// 日付のフォーマット
let formattedFromDate = ref(codeStore.formatDateTime(yosos.fromDate));
let formattedToDate = ref(codeStore.formatDateTime(yosos.toDate));
// 掲載開始・終了日時を監視
watch(
  () => yosos.fromDate,
  (newValue) => {
    formattedFromDate.value = codeStore.formatDateTime(newValue);
  }
);
watch(
  () => yosos.toDate,
  (newValue) => {
    formattedToDate.value = codeStore.formatDateTime(newValue);
  }
);

//let yosoTurn = reactive(yosos.yoso.map(item => item.turn === 0 ? '' : String(item.turn)));
let state = reactive({
  yosoTurn: yosos.yoso.map((item) =>
    item.turn === 0 ? "" : String(Number(item.turn))
  ),
});

const updateYosoTurn = (index, value) => {
  state.yosoTurn[index] = String(value);
  yosos.yoso[index].turn = String(value);
};

watch(yosos.yoso, (newYosos) => {
  state.yosoTurn = newYosos.map((item) =>
    item.turn === 0 ? "" : String(item.turn)
  );
});

const accessToken = computed(() => {
  if (store.getAuthToken) {
    return store.getAuthToken; // トークンの取得取得
  } else {
    return null;
  }
});
//ヘッダ‐の作成
const tokenHeaders = {
  headers: {
    Authorization: `Bearer ${accessToken.value}`,
  },
};

const getMatchedText = (value, list) => {
  if (!value) {
    return null;
  }
  const trimmedValue = value.toString().trim();
  const item = list.find((p) => p.value == trimmedValue);
  return item ? item.text : value;
};

/**
 * 日付文字列を 'yyyy/MM/dd' のフォーマットに変換します。
 *
 * @param {string} dateStr - 変換する日付の文字列。例: "2023-08-07T02:21:10.086529"
 * @returns {string} 'yyyy/MM/dd' のフォーマットに変換された日付文字列。入力が無効または空の場合は空文字を返します。
 */
const formattedDate = (dateStr) => {
  if (!dateStr) return "";
  return format(new Date(dateStr), "yyyy/MM/dd");
};

// 各予想に対して◎(1)と〇(2)が必須で、それぞれの印の重複がないことを確認する関数を定義します
const checkPrediction = () => {
  // それぞれのyosoをチェックします
  let isErr = 0;
  let errMessage = [];
  yosos.yoso.forEach((yoso) => {
    let values = [
      yoso.frame1,
      yoso.frame2,
      yoso.frame3,
      yoso.frame4,
      yoso.frame5,
      yoso.frame6,
    ]; // frame1からframe6の値を取得します
    // yosoのwriterが存在する場合のみ検証を行います
    if (yoso.writer) {
      // ◎(1)と〇(2)が必須であることを検証します

      if (!(values.includes("1") && values.includes("2"))) {
        errMessage.push("エラー: ◎と〇は必須です");
        isErr = isErr + 1;
      }

      // 空欄(0)以外の予想印が重複していないことを検証します
      let uniqueValues = new Set(values.filter((v) => v != 0)); // 0を除外して、一意な値を取得します
      if (uniqueValues.size != values.filter((v) => v != 0).length) {
        errMessage.push("エラー: 予想の印は重複してはいけません");
        isErr = isErr + 1;
      }
    }
  });
  if (!isErr) {
    return false;
  } else {
    alert(errMessage.join("\n"));
    return true;
  }
};

// 必須チェックの関数
const checkRequired = (yoso, yosoTurnIndex) => {
  let errors = [];
  if (Number(yoso.id) === 0) {
    return errors;
  }
  // yoso.writerのチェック
  if (!yoso.writer || yoso.writer.trim() === "") {
    errors.push("記者名は必須です");
  }
  // yosoTurn[index]のチェック
  if (
    typeof yosoTurnIndex === "undefined" ||
    yosoTurnIndex === "" ||
    yosoTurnIndex < 0
  ) {
    errors.push("掲載優先順は正の数字で入力してください");
  }

  return errors;
};

const checkDuplicates = (allYosos) => {
  let errors = [];

  // yoso.idの重複チェック
  const uniqueIds = new Set();
  const duplicateIds = new Set();
  allYosos.forEach((yoso) => {
    if (Number(yoso.id) !== 0) {
      // yoso.idが0でない場合のみ重複チェックを行う
      if (uniqueIds.has(yoso.id)) {
        duplicateIds.add(yoso.id);
      }
      uniqueIds.add(yoso.id);
    }
  });
  if (duplicateIds.size > 0) {
    errors.push(`記者が重複しています`);
  }
  // yoso.turnの重複チェック
  const uniqueTurns = new Set();
  const duplicateTurns = new Set();
  allYosos.forEach((yoso) => {
    // yoso.turnを数値に変換
    const turn = Number(yoso.turn || 0);
    if (Number(yoso.id) !== 0 && turn !== 0) {
      // yoso.idとyoso.turnが0でない場合のみ重複チェックを行う
      if (uniqueTurns.has(turn)) {
        duplicateTurns.add(turn);
      }
      uniqueTurns.add(turn);
    }
  });
  if (duplicateTurns.size > 0) {
    errors.push(`掲載優先順が重複しています`);
  }
  return errors;
};

const updateJournalistName = (yoso, index) => {
  const writersArray = Object.values(writers.value);
  const selectedWriter = writersArray.find(
    (writer) => writer.id.toString() === yoso.id.toString()
  );
  if (selectedWriter) {
    yoso.writer = selectedWriter.journalistName;
    yoso.turn = String(selectedWriter.publicationOrder);
    state.yosoTurn[index] = String(selectedWriter.publicationOrder);
    console.log(yoso.turn, selectedWriter.publicationOrder);
    console.log(state.yosoTurn);
  } else {
    yoso.writer = "";
    yoso.turn = 0;
    yoso.frame1 = 0;
    yoso.frame2 = 0;
    yoso.frame3 = 0;
    yoso.frame4 = 0;
    yoso.frame5 = 0;
    yoso.frame6 = 0;
    state.yosoTurn[index] = "";
  }
};

const removeEmptyYosos = (yoso) => {
  return yoso.filter((yoso) => yoso.id !== 0);
};

//検索中フラグ
let isSearching = ref(false);

const formatNewDate = () => {
  const newDate = new Date();
  return `${newDate.getFullYear()}-${(newDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${newDate.getDate().toString().padStart(2, "0")}`;
};

const initialDate = formatNewDate();

const search_yoso = ref({
  date: initialDate,
  place: "",
  race: "",
});

const searched_yoso = ref({
  date: null,
  place: null,
  race: null,
});

const apiUrl = computed(() =>
  apiStore.getYosoPath(
    search_yoso.value.date,
    search_yoso.value.place,
    search_yoso.value.race
  )
);
const searchedApiUrl = computed(() =>
  apiStore.getYosoPath(
    searched_yoso.value.date,
    searched_yoso.value.place,
    searched_yoso.value.race
  )
);
const writerUrl = apiStore.getWritersPath;
const places = codeStore.places;
const raceNos = codeStore.raceNo;

// ユーザーが送信ボタンを押したかどうかをトラッキングするref
const hasSubmitted = ref(false);
const isSearchButtonPushed = ref(false);

const isDateInvalid = computed(
  () => hasSubmitted.value && !search_yoso.value.date
);
const isPlaceInvalid = computed(
  () => hasSubmitted.value && !search_yoso.value.place
);
const isRaceInvalid = computed(
  () => hasSubmitted.value && !search_yoso.value.race
);

const writers = ref([
  {
    id: "",
    journalistName: "",
    name: "",
    publicationOrder: 0,
  },
]);

const players = ref({
  player1: "",
  player2: "",
  player3: "",
  player4: "",
  player5: "",
  player6: "",
});

const absences = ref([false, false, false, false, false, false]);

/**
 * 欠場フラグabsencesの値に基づいてframeの値を更新する関数
 */
const updateFrameBasedOnAbsences = () => {
  absences.value.forEach((absent, index) => {
    if (absent) {
      const frameKey = `frame${index + 1}`;
      yosos.yoso.forEach((item) => {
        console.log(item[`id`]);

        //コンピュータ予想の場合に欠場フラグを無効化
        if (item[`id`] !== 2) item[frameKey] = 0;
      });
    }
  });
};

// 必要なデータのみを抽出してrefのデータ構造を更新する関数
const updateDataFromResponse = (data) => {
  // players のデータを更新
  console.log(players.value, data, writers.value);
  Object.keys(players.value).forEach((key) => {
    players.value[key] = data[key];
    console.log(players.value[key], data[key]);
  });

  // 欠場フラグ のデータを更新
  absences.value.forEach((_, index) => {
    const key = `player${index + 1}absence`;
    if (data[key] === "1" || data[key] === 1) {
      absences.value[index] = true;
    } else if (data[key] === "0" || data[key] === 0) {
      absences.value[index] = false;
    } else {
      // ここでは何も行わない
    }
  });

  // 欠場フラグの値に基づいてframeの値を更新
  updateFrameBasedOnAbsences();
};

const deleteLine = (index, isDeleteDialog) => {
  if (isDeleteDialog) {
    if (!window.confirm("削除しますか？")) {
      return;
    }
  }
  yosos.yoso[index] = {
    id: 0,
    writer: "",
    frame1: 0,
    frame2: 0,
    frame3: 0,
    frame4: 0,
    frame5: 0,
    frame6: 0,
    turn: 0,
  };

  // yosoTurnの対応するindexも削除
  state.yosoTurn[index] = "";
};

/**
 * ユーザーが送信した情報を元に検索を行う関数
 * @async
 * @function
 * @returns {void}
 */
const searchYoso = async () => {
  console.log(writers.value);
  // 既に検索が行われている場合、新たな検索を実行しない
  if (isSearching.value) {
    return;
  }
  // ユーザーが検索ボタンを押したときにtrueに設定
  hasSubmitted.value = true;
  if (isDateInvalid.value || isPlaceInvalid.value || isRaceInvalid.value) {
    return;
  }

  try {
    isSearching.value = true; // 検索開始直前にフラグを立てます。
    const response = await axios.get(apiUrl.value, tokenHeaders);

    if (response.status === 200) {
      console.log(response.data);
      if (response.data.writeryoso.length < yosos.yoso.length) {
        for (let i = 0; i < yosos.yoso.length; i++) {
          deleteLine(i, false);
        }
      }
      //yososデータを挿入
      yosos.koshinId = response.data.koshinId;
      yosos.toDate = response.data.toDate;
      yosos.fromDate = response.data.fromDate;
      yosos.immediatelyOpen = isNaN(parseInt(response.data.immediatelyOpen, 10))
        ? 0
        : parseInt(response.data.immediatelyOpen, 10);
      yosos.approval = response.data.approval;

      // yosos.yosoとwriteryosoの各要素をマージします
      for (let i = 0; i < yosos.yoso.length; i++) {
        // writeryosoに対応する要素が存在する場合だけマージを実行します
        if (i < response.data.writeryoso.length) {
          yosos.yoso[i] = { ...yosos.yoso[i], ...response.data.writeryoso[i] };
          // yosoTurnを更新します
          state.yosoTurn[i] =
            yosos.yoso[i].turn === 0 ? "" : String(yosos.yoso[i].turn);
        }
      }
      updateDataFromResponse(response.data);

      searched_yoso.value = JSON.parse(JSON.stringify(search_yoso.value));

      router.push({
        name: "Search",
        params: {
          date: search_yoso.value.date,
          place: search_yoso.value.place,
          race: search_yoso.value.race,
        },
      });

      isSearchButtonPushed.value = true;
    }
  } catch (error) {
    console.error(error);
    const statusCode = error.response && error.response.status;
    console.error(statusCode);
    // ステータスコードに応じたエラーハンドリング
    if (statusCode) {
      switch (statusCode) {
        case 400:
          alert("Bad Request - リクエストが不正です");
          break;
        case 401:
          alert("Unauthorized - 認証エラーです");
          break;
        case 403:
          alert("Forbidden - アクセス権限がありません");
          break;
        case 404:
          alert("Not Found - レースが存在しません");
          break;
        case 500:
          alert("Internal Server Error - サーバーエラーです");
          break;
        default:
          alert(`Unknown error - ステータスコード: ${statusCode}`);
      }
    } else {
      alert("エラーが発生しましたが、ステータスコードを取得できませんでした");
    }
  } finally {
    isSearching.value = false; // 検索終了後（成功・失敗を問わず）にフラグを戻す
  }
};

const searchWriter = async () => {
  // ユーザーが送信ボタンを押したときにtrueに設定
  try {
    const response = await axios.get(writerUrl, tokenHeaders);
    if (response.status == 200) {
      writers.value = Object.assign({}, response.data);
    }
  } catch (error) {
    alert("記者が取得できませんでした。", error);
  }
};

onMounted(async () => {
  try {
    await searchWriter();
  } catch (error) {
    console.error(error);
  }
});

// パラメータの変更を監視
watch(
  () => route.params,
  async (newParams) => {
    if (
      !isSearching.value &&
      newParams.date &&
      newParams.place &&
      newParams.race
    ) {
      try {
        // 現在のパラメータをsearch_yosoにセット
        search_yoso.value.date = newParams.date;
        search_yoso.value.place = newParams.place;
        search_yoso.value.race = newParams.race;
        // 検索を実行
        await searchYoso();
      } catch (error) {
        console.error(error);
      }
    }
  },
  { immediate: true, deep: true }
);

// yosos.yoso の変更を監視する
/* watch(
  () => yosos.yoso,
  (newValue) => {
    newValue.sort((a, b) => {
      if (!a.turn && !b.turn) return 0; // 両方が0や空文字の場合は同じ位置を保持
      if (!a.turn) return 1; // aが0や空文字の場合、bの後に来る
      if (!b.turn) return -1; // bが0や空文字の場合、aの後に来る
      return a.turn - b.turn; // それ以外の場合は、turnの値で昇順にソート
    });
  },
  { immediate: true, deep: true }
); // deep: true でネストされたプロパティも監視する
 */
const sendYoso = async () => {
  // ユーザーが送信ボタンを押したときにtrueに設定
  hasSubmitted.value = true;

  let requiredErrors = [];
  yosos.yoso.forEach((yoso, index) => {
    let errors = checkRequired(yoso, state.yosoTurn[index]);
    if (errors.length) {
      requiredErrors = [...requiredErrors, ...errors];
    }
  });
  let sendYosoData = JSON.parse(JSON.stringify(yosos));
  // state.yosoTurnの値をyosos.yosoにコピー
  state.yosoTurn.forEach((turnValue, index) => {
    sendYosoData.yoso[index].turn = turnValue === "" ? 0 : Number(turnValue);
  });

  // 重複チェックを実行
  const duplicateErrors = checkDuplicates(yosos.yoso);
  if (duplicateErrors.length) {
    requiredErrors = [...requiredErrors, ...duplicateErrors];
  }

  if (requiredErrors.length) {
    alert(requiredErrors.join("\n"));
    return;
  }

  // 予想の検証
  if (checkPrediction()) {
    // エラーがある場合はここで終了します
    console.error("予想印エラー");
    return;
  }

  sendYosoData.fromDate = formattedFromDate.value;
  sendYosoData.toDate = formattedToDate.value;

  if (sendYosoData.yoso) {
    sendYosoData.yoso = removeEmptyYosos(sendYosoData.yoso);
  }

  try {
    const response = await axios.put(
      searchedApiUrl.value,
      sendYosoData,
      tokenHeaders
    );

    if (response.status === 200) {
      alert("登録しました");

      // yosos.yosoの変更をトリガー
      yosos.yoso = [...yosos.yoso];
    } else {
      alert("データの取得に失敗しました");
    }
  } catch (error) {
    alert("登録に失敗しました。", error);
  }
};
</script>

<style scoped>
.boat_color1 {
  background: #ebebeb !important;
  color: #000;
}

.boat_color2 {
  background: #505050 !important;
  color: #fff;
}

.boat_color3 {
  background: #f04141 !important;
  color: #fff;
}

.boat_color4 {
  background: #4184d0 !important;
  color: #fff;
}

.boat_color5 {
  background: #ece962 !important;
  color: #000;
}

.boat_color6 {
  background: #54b74d !important;
  color: #fff;
}

.send_button {
  width: auto;
}

.separate {
  display: flex;
  flex-direction: column;
  margin: 10px;
}

.send_button {
  width: 40%;
}

.search_race {
  margin: 0.5em 0;
  min-width: 50%;
}

.searched-race {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 50%;
}

.searched-race-box {
  margin-bottom: 0.5rem;
}

.searched-race div {
  background: #cee6f1;
  padding: 1rem;
  font-size: large;
}

.search-button-box {
  margin: 1rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-button-box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.error-message {
  white-space: nowrap;
  text-align: center;
  color: red;
  font-size: 12px;
  margin: 0.1rem;
}

#immediate {
  margin: 0.2em;
  margin-left: 0.4em;
}

.table_waku_title > .table_mark {
  text-align: center;
}

.input_name input {
  width: 92% !important;
  margin: 0;
  border: none;
}

.input_name input:focus-visible {
  outline: 0;
}

.input_name {
  width: 7rem;
}

.input_name input {
  max-width: 95%;
}

.delete_button {
  height: 1.6rem !important;
}

.disabled-color,
.disabled-color input,
.disabled-color select {
  background: #dbdbdb;
  opacity: 0.6;
}

.separate button {
  width: 5rem;
}

.ketujou {
  position: absolute;
}

.ketujou-disabled,
.ketujou-disabled select,
.ketujou-disabled .ketujou {
  background-color: #dbdbdb !important;
}
</style>
